<div *ngFor="let row of filteredLayout; trackBy: rowTrackBy" class="row tile-row">
  <ng-container *ngFor="let tile of row; trackBy: tileTrackBy">
    <app-homepage-tile
      [type]="adaptiveTypeMap[tile.rowType][tile.size]"
      [title]="tile.rawTitle || tile?.title"
      [linkPath]="tile.linkPath"
      [linkText]="tile?.linkText"
      [class]="'homepage-tile-' + tile.module"
      [custom]="tile?.custom"
    >
      <ng-container [ngSwitch]="tile.module">
        <ng-container *ngxPermissionsOnly="['CONFIG_DASHBOARD_ENABLED']">
          <app-dashboard-main *ngSwitchCase="'dashboard'" [tile]="true"></app-dashboard-main>
        </ng-container>

        <app-tasks-tile-page
          *ngSwitchCase="'taskmanager'"
          [type]="adaptiveTypeMap[tile.rowType][tile.size]"
        ></app-tasks-tile-page>
        <app-tile-sso *ngSwitchCase="'sso'" [type]="adaptiveTypeMap[tile.rowType][tile.size]"></app-tile-sso>
        <app-news-tile *ngSwitchCase="'news'" [type]="adaptiveTypeMap[tile.rowType][tile.size]"></app-news-tile>
        <app-book-tile *ngSwitchCase="'book'" [type]="adaptiveTypeMap[tile.rowType][tile.size]"></app-book-tile>
        <app-loyalty-tile
          *ngSwitchCase="'loyalty'"
          [type]="adaptiveTypeMap[tile.rowType][tile.size]"
        ></app-loyalty-tile>
        <app-banner-tile *ngSwitchCase="'banner'" [type]="adaptiveTypeMap[tile.rowType][tile.size]"></app-banner-tile>
      </ng-container>
    </app-homepage-tile>
  </ng-container>
</div>
